/* eslint-disable no-sequences */
/* eslint-disable no-plusplus */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getCookies } from "../hooks/useCookies";
import { SERVER_BASE_URL } from "./apiConstants";

function toFormData(data, formData = new FormData(), parentKey = '') {
  if (data && typeof data === 'object' && !(data instanceof File)) {
    Object.keys(data).forEach(key => {
      const value = data[key];
      const formKey = parentKey ? `${parentKey}[${key}]` : key;
      
      if (value instanceof File) {
        formData.append(formKey, value);
      } else if (value && typeof value === 'object') {
        toFormData(value, formData, formKey);
      } else {
        formData.append(formKey, value);
      }
    });
  } else if (data !== null && data !== undefined) {
    formData.append(parentKey, data);
  }
  return formData;
}

export const Entry = createAsyncThunk("api/create", async (data) => {
  const headers = {
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${getCookies("Token")}`,
  };
  const formData = new FormData();
  const { actionUrl } = data;
  const { actionMethod } = data;
  delete data.actionUrl;
  delete data.actionMethod;
  const filesToAppend =
    Object.keys(data).length && data.apiData.File ? data.apiData.File : [];
  
  // Check if there's an image file to upload
  const imageFile = data.apiData?.image instanceof File ? data.apiData.image : null;
  
  const hasFiles = filesToAppend.length > 0 || imageFile;
  
  if (filesToAppend.length) {
    for (let i = 0; i < filesToAppend.length; i++) {
      formData.append("File", filesToAppend[i]);
    }
    delete data.apiData.File;
  }
  
  // Append image file if present
  if (imageFile) {
    formData.append("image", imageFile);
    delete data.apiData.image;
  }
  
  if (hasFiles) {
    headers["Content-Type"] = "multipart/form-data";
  }
  switch (actionMethod) {
    case "post":
      return axios
        .post(
          `${SERVER_BASE_URL}/${actionUrl}`,
          hasFiles
            ? toFormData(data.apiData, formData)
            : data.apiData,
          { headers },
          {
            headers,
          }
        )
        .then((response) => response.data)
        .catch((e) => e.response.data);
    case "patch":
      console.log(data.apiData);
      return axios
        .patch(
          `${SERVER_BASE_URL}/${actionUrl}`,
          hasFiles
            ? toFormData(data.apiData, formData)
            : data.apiData,
          {
            headers,
          }
        )
        .then((response) => response.data)
        .catch((e) => e.response.data);

    case "delete":
      return axios
        .delete(`${SERVER_BASE_URL}/${actionUrl}`, { headers })
        .then((response) => response.data)
        .catch((e) => e.response.data);
    default:
      return axios
        .get(`${SERVER_BASE_URL}/${actionUrl}`, { headers })
        .then((response) => response.data)
        .catch((e) => e.response.data);
  }
});

const EntrySlice = createSlice({
  name: "api",
  initialState: {
    loading: false,
    Data: {},
    error: "",
  },
  extraReducers: {
    [Entry.pending]: (state) => {
      /* eslint-disable no-param-reassign */
      state.loading = true;
    },
    [Entry.fulfilled]: (state, action) => {
      state.loading = false;
      state.Data = action.payload;
    },
    [Entry.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default EntrySlice.reducer;
